import { MessageDefinitionEditScreen } from "./message-definition-edit.screen";
import { Paths } from "../../routes/paths";
import { type RouteDefinition } from "../../routes/route-definition";

export const MessageDefinitionEditRoutes: RouteDefinition[] = [
	{
		path: Paths.messageDefinitions.withIdPlaceholder().edit.path,
		element: <MessageDefinitionEditScreen />,
		requiredPermissions: ["UserInAccountPermission_MessageDefinitionAdmin_Modify"],
	},
];
